

















import { toCzj, toV } from '@/app/core/utils'
import { Component, Mixins } from 'vue-property-decorator'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class CommentItem extends Mixins(RecommendItem) {
  get goDetailExposure() {
    const { uid, id } = this.value
    return `200020||${JSON.stringify({ fuid: uid, labelid: id, tabname: this.tab.tabName })}`
  }
  goDetail() {
    const { uid, id } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200020', positionParam: { fuid: uid, labelid: id, tabname: this.tab.tabName } })
  }

  get linkUrl() {
    if (!this.value.businessType || this.value.businessType == 21) {
      const query: any = {
        commentId: this.value.id,
        ht: 'look',
      }
      if (this.value.type == 6) {
        // 月嫂
        query.workerCode = this.value.rid
      }
      return this.kwtarget(
        toV(
          {
            name: 'evaluate',
            query,
          },
          false
        )
      )
    } else {
      return this.kwtarget(toCzj(`https://m.czj100.com/look/${this.value.id}`, false))
    }
  }
}
